import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

import {ReactComponent as SVGClose} from '../../assets/close.svg';
import {ReactComponent as SVGWorld} from '../../assets/world.svg';
import GetYoutubeID from "lib/GetYoutubeID";

export default function (props) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({id: props.media});
    
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };
    
    return (
        <div className={`experience-media ${( parseInt(props.media.isDeleted)  !== 0 && "removed")}`} ref={setNodeRef} style={style}  >
            <div className={`wrapper media-handle`}>
                <span className="media-delete-icon" onClick={() => { props.onClickDelete.apply(null, [props.media])}}>
                    <SVGClose/>
                </span>
                <div className="image-box contain" {...attributes} {...listeners}>
                    {
                        props.media.ExpMediaType === 'image' && props.media.ExpMediaURL &&
                        <img src={props.media.ExpMediaURL}/>
                    }
                    {
                        props.media.ExpMediaType === 'youtube' && props.media.ExpMediaURL &&
                        <img src={`https://img.youtube.com/vi/${GetYoutubeID(props.media.ExpMediaURL)}/mqdefault.jpg`}/>
                    }
                    {
                        props.media.ExpMediaType === 'website' && props.media.ExpMediaURL &&
                        <SVGWorld/>
                    }
                </div>
                {
                    props.media.ExpMediaType === 'website' && props.media.ExpMediaURL &&
                    <span className="label-name">{props.media.ExpMediaURL}</span>
                }
            </div>
        </div>
    );
}